import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';
import { findIndex, filter, find, result } from 'lodash';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  ComponentRef,
  ViewContainerRef,
  ComponentFactoryResolver,
  TemplateRef
} from '@angular/core';
import { Logger } from '@app/core';
import {
  ProcesoSecundario,
  ConfirmComponent,
  TareaInicioFinalizacionSecundaria,
  Static,
  TareaEstado,
  TareaTipo,
  TramiteBasico,
  Microproceso,
  Const,
  Tarea,
  Tramite,
  ActividadBase,
  TramiteBase,
  ProcesoBase,
  Categoria,
  BaseControl,
  TaskCompletionParams,
  SecundariaFinalizacion,
  TipoFinalizacionSecundaria
} from '@app/shared';
import { ProcessAutomationService } from '../shared';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/Subscription';
import { ManageSecondaryCompletionsDataService } from './shared/manage-secondary-completions.data.service';
import { ManageSecondaryCompletionsFormService } from './shared/manage-secondary-completions.form.service';
import { ManageTaskService } from '../shared/manage-task.service';
import { FormGroup } from '@angular/forms';
import { FlowTitle } from '@app/shared/title';
import { HelperFlowService } from '@app/shared/services/helper-flow.service';
import { NotifierService } from '@app/shared/services/notifier.service';
import { Subject } from 'rxjs';

const log = new Logger('ManageSecondaryCompletionsComponent');

type Action = 'remove' | 'removeDestiny';
// Define las acciones posibles para una tarea o actividad
type actionManage = 'select' | 'run';
interface FinalTaskSecondaryCompletion  {
  id: number;
  nombre: string;
  descripcion: string;
  tarea_estado: TareaEstado;
  tarea_tipo: TareaTipo;
  actividad: ActividadBase;
  tramite: TramiteBase;
  proceso: ProcesoBase;
  categoria: Categoria;
  tipo_finalizacion: TipoFinalizacionSecundaria;
  parametros: any;
  hiddenTask: boolean;
  controls?: Array<BaseControl<any>>;
  form?: FormGroup;
}

interface CompletionSecondary {
  task_init: TareaInicioFinalizacionSecundaria;
  destination_task: Array<FinalTaskSecondaryCompletion>;
}

interface DestinationIndex {
  indexCompletion: number;
  destinationIndex: number;
}

@Component({
  selector: 'iw-manage-secondary-completions',
  templateUrl: './manage-secondary-completions.component.html',
  styleUrls: ['./manage-secondary-completions.component.scss'],
  providers: [
    ProcessAutomationService,
    ManageSecondaryCompletionsDataService,
    ManageSecondaryCompletionsFormService,
    HelperFlowService
  ]
})
export class ManageSecondaryCompletionsComponent implements OnInit, OnDestroy {

  // Controla la entrada de las secundarias al componente
  @Input()
  set secondary (s: ProcesoSecundario) {
    this._secondary = s;
    this.loadCompletions(true);
  }
  // Define la pregunta del componente de confirmacion
  question = '';
  // Index de la finalizacion seleccionada
  indexCompletionSelect = -1;
  // Define cuando se esta cargando un flujo
  isLoadingFlow = false;
  // Define si muestra o no el contenedor del flujo
  viewFlow = false;
  // Contiene de forma agrupada las finlizaciones de la secundaria
  groupSecondaryCompletions: Array<CompletionSecondary> = [];
  // Historial de consulta del tramite seleccionado
  historyFlow: Array<number> = [];
  // Lista de parametros validos para la key 'parametros' de una finalización de una tarea
  params: TaskCompletionParams[];
  // Flujo actual consultado
  flow: TramiteBasico | Microproceso;
  // Configuración para generar el título del flujo
  configFlowTitle: Partial<FlowTitle>;
  // Define la accion a realizar
  action: Action;
  // Index de la tarea de destino seleccionada
  selectDestinationIndex: DestinationIndex = {
    indexCompletion: -1,
    destinationIndex: -1
  };
  // Referencia al componente de seleccion de tramites
  selectTramiteRef: ComponentRef<SelectTramiteComponent>;
  // Suscripción a las notificaciones de otros componentes
  private notifications: Subscription;
  // Contiene las finalizaciones de la secundaria
  private _secondary: ProcesoSecundario;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia del control personalizado para el select de tipos
  @ViewChild('selectTypesTpl') private selectTypesTpl: TemplateRef<any>;
  // Anclaje al contenedor donde estara el componente de seleccion de tramites
  @ViewChild('containerSelectTramite', { read: ViewContainerRef }) containerSelectTramite: ViewContainerRef;
  // Referencia del control personalizado para el select de parametros
  @ViewChild('selectParamsTpl') private selectParamsTpl: TemplateRef<any>;
  // Referencia del control personalizado para el select de los estados de el tramite
  @ViewChild('selectStatusTpl') private selectStatusTpl: TemplateRef<any>;
  // Referencia del control personalizado para el select de los estados de el expediente
  @ViewChild('selectStatusExpedientTpl') private selectStatusExpedientTpl: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;

  constructor(
    private sts: ScrollToService,
    private pas: ProcessAutomationService,
    private mscds: ManageSecondaryCompletionsDataService,
    private mscfs: ManageSecondaryCompletionsFormService,
    public mts: ManageTaskService,
    private hfs: HelperFlowService,
    private toastr: ToastrService,
    private ns: NotifierService,
    private cfr: ComponentFactoryResolver,
  ) {
    this.params = filter(Const.TASK_COMPLETION_PARAMS, data => {
      return data.required === false && data.name !== 'reactivar_tareas';
    });
  }

  ngOnInit() {
    this.notificationsComponent();
  }

  ngOnDestroy() {
    this.notifications.unsubscribe();
    this.destroy.next();
    this.destroy.complete();
  }

  get secondary(): ProcesoSecundario {
    return this._secondary;
  }

  /**
   * Controla las acciones en los flujos dependiendo del tipo de tarea que se esta seleccionando
   *
   * @param {*} [action]
   * @param {*} [data]
   * @memberof ManageSecondaryCompletionsComponent
   */
  defineAction(action?: any, data?: any) {
    if (this.indexCompletionSelect >= 0) {
      this.defineActionFlowSecondary(action, data);
    } else if (this.selectDestinationIndex.indexCompletion >= 0) {
      this.defineActionFlowProcess(action, data);
    }
  }

  /**
   * Agregar finalización
   *
   * @memberof ManageSecondaryCompletionsComponent
   */
  addCompletion() {
    if (this.groupSecondaryCompletions && this.groupSecondaryCompletions.length) {
      this.groupSecondaryCompletions.push({
        task_init: null,
        destination_task: [{
          id: null,
          nombre: null,
          descripcion: null,
          tarea_estado: {
            id: null,
            nombre: null,
            descripcion: null
          },
          tarea_tipo: {
            id: null,
            nombre: null,
            descripcion: null
          },
          actividad: {
            id: null,
            nombre: null,
            descripcion: null
          },
          tramite: {
            id: null,
            nombre: null,
            descripcion: null
          },
          proceso: {
            id: null,
            nombre: null,
            descripcion: null
          },
          categoria: {
            id: null,
            nombre: null,
            descripcion: null
          },
          parametros: {},
          tipo_finalizacion: {
            id: null,
            nombre: null,
            descripcion: null
          },
          hiddenTask: true,
          controls: this.loadControlsParameters()
        }]
      });
      setTimeout(() => {
        let target = '';
        target = 'completion_' + (this.groupSecondaryCompletions.length - 1);
        this.sts.scrollTo({
          target: target
        } as ScrollToConfigOptions);
      });
    }
  }

  /**
   * Agregar un destino para la finalizacion
   *
   * @memberof ManageSecondaryCompletionsComponent
   */
  addDestination(indexCompletion: number) {
    if (
      this.groupSecondaryCompletions[indexCompletion] &&
      this.groupSecondaryCompletions[indexCompletion].destination_task.length
    ) {
      this.groupSecondaryCompletions[indexCompletion].destination_task.push({
        id: null,
        nombre: null,
        descripcion: null,
        tarea_estado: {
          id: null,
          nombre: null,
          descripcion: null
        },
        tarea_tipo: {
          id: null,
          nombre: null,
          descripcion: null
        },
        actividad: {
          id: null,
          nombre: null,
          descripcion: null
        },
        tramite: {
          id: null,
          nombre: null,
          descripcion: null
        },
        proceso: {
          id: null,
          nombre: null,
          descripcion: null
        },
        categoria: {
          id: null,
          nombre: null,
          descripcion: null
        },
        parametros: {},
        tipo_finalizacion: {
          id: null,
          nombre: null,
          descripcion: null
        },
        hiddenTask: true,
        controls: this.loadControlsParameters()
      });
      setTimeout(() => {
        let target = '';
        target = 'completion_' + indexCompletion +
                 'destination_' + (this.groupSecondaryCompletions[indexCompletion].destination_task.length - 1);
        this.sts.scrollTo({
          target: target
        } as ScrollToConfigOptions);
      });
    }
  }

  /**
   * Ejecuta una accion especifica con confirmacion
   *
   * @param {Action} action
   * @param {*} [data]
   * @memberof ManageSecondaryCompletionsComponent
   */
  runAction(action: Action, data?: any) {
    this.action = action;
    switch (action) {
      case 'remove':
        this.question = '¿Realmente desea eliminar la finalización?';
        this.indexCompletionSelect = data;
        break;
      case 'removeDestiny':
        this.question = '¿Realmente desea eliminar la finalización?';
        this.selectDestinationIndex = data;
        break;
    }
    this.confirmAction.open();
  }

  /**
   * Controla la respuesta de confirmacion
   *
   * @param {boolean} resp
   * @memberof ManageSecondaryCompletionsComponent
   */
  actionComfirm(resp: boolean) {
    if (resp) {
      switch (this.action) {
        case 'remove':
          this.removeCompletion();
          this.action = null;
          break;
        case 'removeDestiny':
          this.removeDestiny();
          this.action = null;
          break;
      }
    }
  }

  /**
   * Carga el flujo de la secundaria actual para seleccionar la tarea inicial de la finalizacion
   *
   * @param {number} indexSelect
   * @memberof ManageSecondaryCompletionsComponent
   */
  selectTaskInit(indexSelect: number) {
    this.indexCompletionSelect = indexSelect;
    this.loadSecondaryFlow();
    log.debug('indexSelect', indexSelect);
  }

  /**
   * controla la accion por parte del usuario para cargar el flujo especificado
   *
   * @param {number} indexCompletionSelect
   * @param {number} indexDestinationSelect
   * @memberof ManageSecondaryCompletionsComponent
   */
  async selectTaskDestination(indexCompletionSelect: number, indexDestinationSelect: number) {
    this.selectDestinationIndex = {
      indexCompletion: indexCompletionSelect,
      destinationIndex: indexDestinationSelect
    };
    this.viewFlow = true;
    if (this.containerSelectTramite) {
      this.containerSelectTramite.clear();
      const factory = this.cfr.resolveComponentFactory(SelectTramiteComponent);
      this.selectTramiteRef = this.containerSelectTramite.createComponent(factory);
    }
    if (
      this.groupSecondaryCompletions[indexCompletionSelect] &&
      this.groupSecondaryCompletions[indexCompletionSelect].destination_task[indexDestinationSelect] &&
      this.groupSecondaryCompletions[indexCompletionSelect].destination_task[indexDestinationSelect].id
    ) {
      // tslint:disable-next-line: max-line-length
      const taskDestination = this.groupSecondaryCompletions[indexCompletionSelect].destination_task[indexDestinationSelect];
      await this.selectTramiteRef.instance.reload('category', taskDestination.categoria.id);
      await this.selectTramiteRef.instance.reload('process', taskDestination.proceso.id);
      await this.selectTramiteRef.instance.reload('tramite', taskDestination.tramite.id);
      this.loadProcessFlow(taskDestination.tramite.id);
    } else {
      this.selectTramiteRef.instance.history = {};
    }
    log.debug('index_selection', this.selectDestinationIndex);
  }

  /**
   * Se encarga de cerrar la vista de el flujo
   *
   * @memberof ManageSecondaryCompletionsComponent
   */
  closeViewFlow() {
    this.historyFlow = [];
    this.viewFlow = false;
    this.isLoadingFlow = false;
    this.flow = null;
    this.configFlowTitle = null;
    if (this.selectDestinationIndex.indexCompletion >= 0) {
      const indexScrollCompletion = this.selectDestinationIndex.indexCompletion;
      const indexScrollDestination = this.selectDestinationIndex.destinationIndex;
      this.containerSelectTramite.clear();
      this.selectTramiteRef.destroy();
      setTimeout(() => {
        const target = 'completion_' + indexScrollCompletion + 'destination_' + indexScrollDestination;
        log.debug('posicion scroll', target);
        this.sts.scrollTo({
          target: target
        } as ScrollToConfigOptions);
      });
      this.selectDestinationIndex = {
        indexCompletion: -1,
        destinationIndex: -1
      };
    } else {
      const indexScroll = this.indexCompletionSelect;
      setTimeout(() => {
        let target = '';
        target = 'completion_' + indexScroll;
        log.debug('posicion scroll', target);
        this.sts.scrollTo({
          target: target
        } as ScrollToConfigOptions);
      });
      this.indexCompletionSelect = -1;
    }
  }

  /**
   * Guarda la instancia de un formulario creado para la tarea de destino de una finalizacion
   *
   * @param {FormGroup} form
   * @param {number} indexCompletion
   * @param {number} indexDestination
   * @memberof ManageSecondaryCompletionsComponent
   */
  accumulateForm(form: FormGroup, indexCompletion: number, indexDestination: number) {
    this.groupSecondaryCompletions[indexCompletion].destination_task[indexDestination].form = form;
    form.get('tipo_finalizacion').valueChanges.subscribe((change: any) => {
      const selectionDestinationTask = this.showTargetTaskFn(change);
      if (!selectionDestinationTask) {
        this.groupSecondaryCompletions[indexCompletion].destination_task[indexDestination].hiddenTask = true;
        this.groupSecondaryCompletions[indexCompletion].destination_task[indexDestination].id = null;
        this.groupSecondaryCompletions[indexCompletion].destination_task[indexDestination].nombre = null;
        this.groupSecondaryCompletions[indexCompletion].destination_task[indexDestination].descripcion = null;
        this.groupSecondaryCompletions[indexCompletion].destination_task[indexDestination].actividad = {
          id: null,
          nombre: null,
          descripcion: null
        };
        this.groupSecondaryCompletions[indexCompletion].destination_task[indexDestination].tramite = {
          id: null,
          nombre: null,
          descripcion: null
        };
        this.groupSecondaryCompletions[indexCompletion].destination_task[indexDestination].proceso = {
          id: null,
          nombre: null,
          descripcion: null
        };
        this.groupSecondaryCompletions[indexCompletion].destination_task[indexDestination].categoria = {
          id: null,
          nombre: null,
          descripcion: null
        };
      } else {
        this.groupSecondaryCompletions[indexCompletion].destination_task[indexDestination].hiddenTask = false;
      }
    });
  }

  /**
   * Carga el flujo del tramite seleccionado
   *
   * @memberof ReportsStructureDataComponent
   */
  async loadProcessFlow(idTramite: number) {
    if (idTramite > 0) {
      log.debug('id_proceso', idTramite);
      this.isLoadingFlow = true;
      this.viewFlow = true;
      await this.mscds.getDefaultTramite(idTramite)
        .then(data => {
          if (data.actividades && data.actividades.length) {
            this.historyFlow = [idTramite];
            log.debug('history', this.historyFlow);
            this.flow = data;
            this.flow.actividades = this.hfs.refineActivities(this.flow.actividades);
            log.debug('flow', this.flow);
            this.configFlowTitle = this.hfs.getFlowTitle(this.flow as Tramite);
            this.configFlowTitle.lengthFlowsHistory = this.historyFlow.length;
          } else {
            this.historyFlow = [];
            this.viewFlow = false;
            this.isLoadingFlow = false;
            this.flow = null;
            this.configFlowTitle = null;
            this.toastr.warning(
              'No se encuentra un flujo configurado para el proceso seleccionado.',
              'Flujo no configurado.'
            );
          }
          this.isLoadingFlow = false;
        })
        .catch((err) => {
          this.isLoadingFlow = false;
          log.debug(err);
        });
    } else {
      this.historyFlow = [];
      this.viewFlow = false;
      this.isLoadingFlow = false;
      this.flow = null;
      this.configFlowTitle = null;
    }
  }

  /**
   * Retorna las finalizaciones configuradas
   *
   * @readonly
   * @type {(SecundariaFinalizacion[] | false)}
   * @memberof ManageSecondaryCompletionsComponent
   */
  get completions(): SecundariaFinalizacion[] | false {
    const completions: SecundariaFinalizacion[] | false = [];
    let valid = true;

    if (this.groupSecondaryCompletions && this.groupSecondaryCompletions.length) {
      for (const completion of this.groupSecondaryCompletions) {
        if (this.groupSecondaryCompletions.length === 1) {
          if (!completion || !completion.task_init || !completion.task_init.id) {
            break;
          }
        }
        if (completion.task_init.id !== null && completion.destination_task && completion.destination_task.length) {
          for (const destination of completion.destination_task) {
            if (destination.form.valid) {
              const newCompletion: SecundariaFinalizacion = {
                tarea_inicio: completion.task_init.id,
                tarea_destino: destination.id,
                tipo_finalizacion: destination.form.value.tipo_finalizacion,
                parametros: this.getParameters(destination.form)
              };
              completions.push(newCompletion);
            } else {
              valid = false;
              break;
            }
          }
        } else {
          valid = false;
        }
      }
    }
    if (valid) {
      return completions;
    } else {
      return false;
    }
  }

  /**
   * Retorna los parametros configurados en un formulario de una tarea de destino
   *
   * @private
   * @param {FormGroup} form
   * @returns {Object}
   * @memberof ManageSecondaryCompletionsComponent
   */
  private getParameters(form: FormGroup): Object {
    log.debug('form parametros', form.value);
    const parameters = {};
    const parametersForm = form.controls['parametros'].value;
    if (parametersForm && parametersForm.length) {
      parametersForm.forEach((key: string) => {
        parameters[key] = true;
      });
    }
    if (form.controls['cambioEstado'].value) {
      parameters['estado_tramite'] = form.controls['estado'].value;
    }
    if (form.controls['cambioEstadoExpediente'].value) {
      parameters['estado_expediente'] = form.controls['estadoExpediente'].value;
    }
    return parameters;
  }

  /**
   * Controla las notificaciones del componente
   *
   * @private
   * @memberof ManageSecondaryCompletionsComponent
   */
  private notificationsComponent() {
    this.notifications = this.ns.get().subscribe(async n => {
      log.debug('notificación', n);
      if (n.source === 'task' && n.instance === 'task_select_init_completion_secondary') {
        // Si se ejecutó el evento click en una tarea del flujo de la tarea inicial
        let action: actionManage;
        // Definir la acción que se quiere hacer con la tarea
        switch (n.action) {
          case 'selectTask':
            // Accion de seleccionar una tarea en el flujo de la tarea inicial
            action = 'select';
            const taskSelect: Partial<Tarea> = n.data.task;
            this.initialTaskSelection(taskSelect);
            break;
          case 'runMicroProcess':
            // Accion de seleccion de un microproceso en el flujo dela tarea inicial
            action = 'run';
            this.defineActionFlowSecondary('openMicroProcess', n.data.task.id);
            break;
        }
      } else if (n.source === 'task' && n.instance === 'task_select_destination_completion_secondary') {
        // Si se ejecutó el evento click en una tarea del flujo de la tarea inicial
        let action: actionManage;
        // Definir la acción que se quiere hacer con la tarea
        switch (n.action) {
          case 'selectTask':
            // Accion de seleccionar una tarea en el flujo de la tarea destino
            action = 'select';
            const taskSelect: Partial<Tarea> = n.data.task;
            this.destinationTaskSelection(taskSelect);
            break;
          case 'runMicroProcess':
            // Accion de seleccion de un microproceso en el flujo dela tarea inicial
            action = 'run';
            this.defineActionFlowProcess('openMicroProcess', n.data.task.id);
            break;
        }
      } else if (n.source === 'task' && n.instance === 'task_init_completion_secondary') {
        // Si se ejecuta el click en la tarea seleccionada como la tarea inicial de la finalización
        const indexSelect = n.data.sharedData.index;
        this.selectTaskInit(indexSelect);
      } else if (n.source === 'task' && n.instance === 'task_destination_completion_secondary') {
        // Si se ejecuta el click en la tarea seleccionada como la tarea inicial de la finalización
        const indexSelect = n.data.sharedData;
        this.selectTaskDestination(indexSelect.indexCompletion, indexSelect.destinationIndex);
      }
    });
  }

  /**
   * Genera los controles de un formulario de una tarea de destino
   *
   * @private
   * @param {FinalTaskSecondaryCompletion} [data]
   * @returns {BaseControl<any>[]}
   * @memberof ManageSecondaryCompletionsComponent
   */
  private loadControlsParameters(data?: FinalTaskSecondaryCompletion): BaseControl<any>[] {
    let controls: BaseControl<any>[] = [];
    let params: string[] = [];
    let status = 0;
    let statusExpedient = 0;
    if (data) {
      if (Object.keys(data.parametros).length) {
        params = Object.keys(data.parametros).filter(item => {
          return item !== 'finalizacion' && item !== 'estado_tramite' && item !== 'estado_expediente';
        });
      }
      if (data.parametros['estado_tramite']) {
        status = data.parametros['estado_tramite'];
      }
      if (data.parametros['estado_expediente']) {
        statusExpedient = data.parametros['estado_expediente'];
      }
    }
    // Generar campos del formulario por default
    controls = this.mscfs.getFields({
      selectTypesTpl: this.selectTypesTpl,
      selectStatusTpl: this.selectStatusTpl,
      selectParamsTpl: this.selectParamsTpl,
      selectStatusExpedientTpl: this.selectStatusExpedientTpl,
      tipo_finalizacion: data ? data.tipo_finalizacion.id : null,
      parametros: params,
      estado_tramite: status,
      estado_expediente: statusExpedient,
    });
    return controls;
  }

  /**
   * Define las acciones a realizar en el flujo de las tareas de destino de finalizacion
   *
   * @private
   * @param {('openMicroProcess' | 'goBack')} [action='goBack']
   * @param {*} [data]
   * @memberof ManageSecondaryCompletionsComponent
   */
  private defineActionFlowProcess(action: 'openMicroProcess' | 'goBack' = 'goBack', data?: any) {
    switch (action) {
      case 'openMicroProcess':
        // Abrir un microproceso en el flujo actual
        if (data) {
          this.runMicroProcess(data);
        }
        break;
      default:
        // Devolverse entre la navegacion de los flujos
        if (this.historyFlow.length > 1) {
          this.historyFlow.pop();
        }
        if (this.historyFlow.length > 1) {
          this.runMicroProcess(this.historyFlow[this.historyFlow.length - 1], true);
        } else {
          this.loadProcessFlow(this.historyFlow[0]);
        }
        break;
    }
  }

  /**
   * Define las acciones a realizar en el flujo de las tareas del proceso secundario
   *
   * @private
   * @param {('openMicroProcess' | 'goBack')} [action='goBack']
   * @param {*} [data]
   * @memberof ManageSecondaryCompletionsComponent
   */
  private defineActionFlowSecondary(action: 'openMicroProcess' | 'goBack' = 'goBack', data?: any) {
    switch (action) {
      case 'openMicroProcess':
         // Abrir un microproceso en el flujo actual
        if (data) {
          this.runMicroProcessSecondary(data);
        }
        break;
      default:
        // Devolverse entre la navegacion de los flujos
        if (this.historyFlow.length > 1) {
          this.historyFlow.pop();
        }
        if (this.historyFlow.length > 1) {
          this.runMicroProcessSecondary(this.historyFlow[this.historyFlow.length - 1], true);
        } else {
          this.loadSecondaryFlow();
        }
        break;
    }
  }

  /**
   * Agrupa las finalizaciones por la tarea de inicio
   *
   * @private
   * @param {boolean} [init=false]
   * @memberof ManageSecondaryCompletionsComponent
   */
  private loadCompletions(init: boolean = false) {
    this.groupSecondaryCompletions = [];
    if (this.secondary && this.secondary.finalizaciones && this.secondary.finalizaciones.length) {
      this.secondary.finalizaciones.forEach(completion => {
        const indexGroup = findIndex(
          this.groupSecondaryCompletions,
          group => group.task_init.id === completion.tarea_inicio.id
        );
        if (completion.tarea_destino) {}
        const destinationTask: FinalTaskSecondaryCompletion = Static.copyObjet(
          completion.tarea_destino
        ) as FinalTaskSecondaryCompletion;
        destinationTask.parametros = Static.copyObjet(completion.parametros);
        destinationTask.tipo_finalizacion = Static.copyObjet(completion.tipo_finalizacion);
        if (this.showTargetTaskFn(destinationTask.tipo_finalizacion.id)) {
          destinationTask.hiddenTask = false;
        } else {
          destinationTask.hiddenTask = true;
        }
        if (indexGroup !== -1) {
          this.groupSecondaryCompletions[indexGroup].destination_task.push(destinationTask);
        } else {
          this.groupSecondaryCompletions.push({
            task_init: Static.copyObjet(completion.tarea_inicio),
            destination_task: [destinationTask]
          });
        }
      });
    } else if (init) {
      this.groupSecondaryCompletions.push({
        task_init: null,
        destination_task: [{
          id: null,
          nombre: null,
          descripcion: null,
          tarea_estado: {
            id: null,
            nombre: null,
            descripcion: null
          },
          tarea_tipo: {
            id: null,
            nombre: null,
            descripcion: null
          },
          actividad: {
            id: null,
            nombre: null,
            descripcion: null
          },
          tramite: {
            id: null,
            nombre: null,
            descripcion: null
          },
          proceso: {
            id: null,
            nombre: null,
            descripcion: null
          },
          categoria: {
            id: null,
            nombre: null,
            descripcion: null
          },
          tipo_finalizacion: {
            id: null,
            nombre: null,
            descripcion: null
          },
          hiddenTask: true,
          parametros: {}
        }]
      });
    }
    this.loadDestination();
  }

  /**
   * Carga los controles basicos de los formularios de las tareas de destino
   *
   * @private
   * @param {boolean} [specific=false]
   * @memberof ManageSecondaryCompletionsComponent
   */
  private loadDestination(specific: boolean = false) {
    if (!specific) {
      if (this.groupSecondaryCompletions.length) {
        this.groupSecondaryCompletions.forEach(completion => {
          if (completion.destination_task && completion.destination_task.length) {
            completion.destination_task.forEach(destination => {
              // tslint:disable-next-line: max-line-length
              destination.controls = this.loadControlsParameters(destination);
            });
          }
        });
      }
    } else {
      if (this.indexCompletionSelect >= 0) {
        this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
          .destination_task.forEach(destination => {
          // tslint:disable-next-line: max-line-length
          destination.controls = this.loadControlsParameters(destination);
        });
      }
      if (this.selectDestinationIndex.indexCompletion >= 0) {
        this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
          .destination_task[this.selectDestinationIndex.destinationIndex]
            .controls = this.loadControlsParameters(
              this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
                .destination_task[this.selectDestinationIndex.destinationIndex]
            );
      }
    }
  }

  /**
   * Consulta el flujo de la secundaria de la cual se configura las finalizaciones
   *
   * @private
   * @memberof ManageSecondaryCompletionsComponent
   */
  private async loadSecondaryFlow() {
    if (this.secondary) {
      const idTramite = this.secondary.id;
      log.debug('id_secundaria', idTramite);
      this.isLoadingFlow = true;
      this.viewFlow = true;
      await this.pas.getDefaultSecondaryProcess(idTramite)
        .then(data => {
          if (data.actividades && data.actividades.length) {
            this.historyFlow = [idTramite];
            log.debug('history', this.historyFlow);
            this.flow = data;
            this.flow.actividades = this.hfs.refineActivities(this.flow.actividades);
            log.debug('flow', this.flow);
            this.configFlowTitle = this.hfs.getFlowTitle(this.flow as Tramite);
            this.configFlowTitle.lengthFlowsHistory = this.historyFlow.length;
          } else {
            this.historyFlow = [];
            this.viewFlow = false;
            this.isLoadingFlow = false;
            this.flow = null;
            this.configFlowTitle = null;
            this.toastr.warning(
              'No se encuentra un flujo configurado para el proceso secundario.',
              'Flujo no configurado.'
            );
          }
          this.isLoadingFlow = false;
        })
        .catch((err) => {
          this.isLoadingFlow = false;
          log.debug(err);
        });
    } else {
      this.historyFlow = [];
      this.viewFlow = false;
      this.isLoadingFlow = false;
      this.flow = null;
      this.configFlowTitle = null;
    }
  }

  /**
   * Consulta el flujo de un microproceso del tramite seleccionado
   *
   * @private
   * @param {number} idMicroProcess
   * @param {boolean} [refresh=false]
   * @memberof ManageSecondaryCompletionsComponent
   */
  private async runMicroProcess(idMicroProcess: number, refresh: boolean = false) {
    if (idMicroProcess) {
      this.isLoadingFlow = true;
      await this.mscds.getDefaultMicroProces(idMicroProcess)
        .then(data => {
          log.debug('id_microproceso', idMicroProcess);
          if (!refresh) {
            this.historyFlow.push(idMicroProcess);
          }
          log.debug('history', this.historyFlow);
          this.flow = data;
          this.flow.actividades = this.hfs.refineActivities(this.flow.actividades);
          log.debug('flow', this.flow);
          this.isLoadingFlow = false;
          this.configFlowTitle = this.hfs.getFlowTitle(this.flow);
          this.configFlowTitle.lengthFlowsHistory = this.historyFlow.length;
        })
        .catch((err) => {
          this.isLoadingFlow = false;
          log.debug(err);
        });
    }
  }

  /**
   * Se encarga de agregar a un grupo de finalizaciones la tarea inicial seleccionada por el usuario
   *
   * @private
   * @param {Partial<Tarea>} taskSelect
   * @memberof ManageSecondaryCompletionsComponent
   */
  private initialTaskSelection(taskSelect: Partial<Tarea>) {
    if (this.validTaskSelect(taskSelect.id)) {
      this.historyFlow = [];
      this.viewFlow = false;
      this.isLoadingFlow = false;
      this.flow = null;
      this.configFlowTitle = null;
      const taskInitCompletion: TareaInicioFinalizacionSecundaria = {
        id: taskSelect.id,
        nombre: taskSelect.nombre,
        descripcion: taskSelect.descripcion,
        actividad: {
          id: taskSelect.tarea_actividad,
          nombre: '',
          descripcion: ''
        },
        tarea_estado: {
          id: taskSelect.tarea_estado.id,
          nombre: taskSelect.tarea_estado.nombre,
          descripcion: taskSelect.tarea_estado.descripcion
        },
        tarea_tipo: {
          id: taskSelect.tarea_tipo.id,
          nombre: taskSelect.tarea_tipo.nombre,
          descripcion: taskSelect.tarea_tipo.descripcion
        }
      };
      this.groupSecondaryCompletions[this.indexCompletionSelect].task_init = taskInitCompletion;
      this.closeViewFlow();
    } else {
      this.toastr.warning(
        'Ya existe una finalización para esta tarea.',
        'Tarea existente.'
      );
    }
  }

  /**
   * Se encarga de agregar una tarea destino a un grupo de finalizaciones del proceso secundario
   *
   * @private
   * @param {Partial<Tarea>} taskSelect
   * @memberof ManageSecondaryCompletionsComponent
   */
  private destinationTaskSelection(taskSelect: Partial<Tarea>) {
    if (this.validDestinationTaskSelect(taskSelect.id)) {
      this.historyFlow = [];
      this.viewFlow = false;
      this.isLoadingFlow = false;
      this.flow = null;
      this.configFlowTitle = null;
      // se configura la informacion de la tarea seleccionada en su respetivo grupo de finalizaciones
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
        .destination_task[this.selectDestinationIndex.destinationIndex].id = taskSelect.id;
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
        .destination_task[this.selectDestinationIndex.destinationIndex].nombre = taskSelect.nombre;
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
        .destination_task[this.selectDestinationIndex.destinationIndex].descripcion = taskSelect.descripcion;
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
        .destination_task[this.selectDestinationIndex.destinationIndex].tarea_estado = taskSelect.tarea_estado;
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
        .destination_task[this.selectDestinationIndex.destinationIndex].tarea_tipo = taskSelect.tarea_tipo;
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
        .destination_task[this.selectDestinationIndex.destinationIndex]
          .tramite = this.selectTramiteRef.instance.tramite;
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
        .destination_task[this.selectDestinationIndex.destinationIndex]
          .proceso = this.selectTramiteRef.instance.process;
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion]
        .destination_task[this.selectDestinationIndex.destinationIndex]
          .categoria = this.selectTramiteRef.instance.category;
      this.closeViewFlow();
    } else {
      this.toastr.warning(
        'Para el grupo de finalización seleccionado esta tarea ya se encuentra configurada como destino.',
        'Tarea de destino existente.'
      );
    }
  }

  /**
   * Consulta el flujo de un microproceso de la secundaria de la cual se configura las finalizaciones
   *
   * @private
   * @param {number} idMicroProcess
   * @param {boolean} [refresh=false]
   * @memberof ManageSecondaryCompletionsComponent
   */
  private async runMicroProcessSecondary(idMicroProcess: number, refresh: boolean = false) {
    if (idMicroProcess) {
      this.isLoadingFlow = true;
      await this.pas.getDefaultSecondaryMicroProces(idMicroProcess)
        .then(data => {
          log.debug('id_microproceso', idMicroProcess);
          if (!refresh) {
            this.historyFlow.push(idMicroProcess);
          }
          log.debug('history', this.historyFlow);
          this.flow = data;
          this.flow.actividades = this.hfs.refineActivities(this.flow.actividades);
          log.debug('flow', this.flow);
          this.isLoadingFlow = false;
          this.configFlowTitle = this.hfs.getFlowTitle(this.flow);
          this.configFlowTitle.lengthFlowsHistory = this.historyFlow.length;
        })
        .catch((err) => {
          this.isLoadingFlow = false;
          log.debug(err);
        });
    }
  }

  /**
   * Elimina la finalizacion seleccionada
   *
   * @private
   * @memberof ManageSecondaryCompletionsComponent
   */
  private removeCompletion() {
    if (this.indexCompletionSelect >= 0) {
      this.groupSecondaryCompletions.splice(this.indexCompletionSelect, 1);
      let indexScroll = 0;
      if (this.indexCompletionSelect > 0) {
        indexScroll = this.indexCompletionSelect - 1;
      }
      setTimeout(() => {
        let target = '';
        target = 'completion_' + indexScroll;
        this.sts.scrollTo({
          target: target
        } as ScrollToConfigOptions);
      });
      this.indexCompletionSelect = -1;
    }
  }

  /**
   * Elimina una tarea de destino de una finalizacion
   *
   * @private
   * @memberof ManageSecondaryCompletionsComponent
   */
  private removeDestiny() {
    if (this.selectDestinationIndex.indexCompletion >= 0) {
      // Se remueve la tarea de destino seleccionada de la finalizacion seleccionada
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion].destination_task.splice(
        this.selectDestinationIndex.destinationIndex, 1
      );
      let indexScrollCompletion = 0;
      let indexScrollDestiniti = 0;
      if (this.selectDestinationIndex.indexCompletion > 0) {
        indexScrollCompletion = this.selectDestinationIndex.indexCompletion - 1;
      }
      if (this.selectDestinationIndex.destinationIndex > 0) {
        indexScrollDestiniti = this.selectDestinationIndex.destinationIndex - 1;
      }
      setTimeout(() => {
        let target = '';
        target = 'completion_' + indexScrollCompletion + 'destination_' + indexScrollDestiniti;
        this.sts.scrollTo({
          target: target
        } as ScrollToConfigOptions);
      });
      this.selectDestinationIndex = {
        indexCompletion: -1,
        destinationIndex: -1
      };
    }
  }

  /**
   * Validad que la tarea inicial no se encuentre ya configurada en los grupos de finalizaciones
   *
   * @private
   * @param {number} idTask
   * @returns {boolean}
   * @memberof ManageSecondaryCompletionsComponent
   */
  private validTaskSelect(idTask: number): boolean {
    let valid = true;
    if (this.groupSecondaryCompletions && this.groupSecondaryCompletions.length) {
      this.groupSecondaryCompletions.forEach((group, index) => {
        if (group.task_init && group.task_init.id === idTask && index !== this.indexCompletionSelect) {
          valid = false;
        }
      });
    }
    return valid;
  }

  /**
   * Validad que la tarea de destino no se encuentre ya configurada en el grupo de finalizaciones seleccionado
   *
   * @private
   * @param {number} idTask
   * @returns {boolean}
   * @memberof ManageSecondaryCompletionsComponent
   */
  private validDestinationTaskSelect(idTask: number): boolean {
    let valid = true;
    if (
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion] &&
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion].destination_task.length
    ) {
      this.groupSecondaryCompletions[this.selectDestinationIndex.indexCompletion].destination_task.forEach(
        (destinationTask, index) => {
        if (destinationTask.id === idTask && index !== this.selectDestinationIndex.destinationIndex) {
          valid = false;
        }
      });
    }
    return valid;
  }

  /**
   * Filtra en los tipos de finalizaciones(con el parametro id) y verifica
   * si el obj filtrado es 'saltar_tarea', de ser asi muestra la tarea de
   * destino.
   *
   * @param {number} id
   * @returns
   * @memberof ManageSecondaryCompletionsComponent
   */
  showTargetTaskFn(id: number) {
    const typeCompletion = find(this.mts.completionTypes, { id: id });
    return result(typeCompletion, 'nombre') === 'saltar_tarea' ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-secondary-completions/manage-secondary-completions.component.ts